import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'


//#region Asset Imports

import * as TEMPLATE from './configuration-profile-create-edit-popup.tpl.html'
import { $COMPILE_SERVICE_NAME, $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { CONFIGURATION_PROFILE_SERVICE_NAME, ConfigurationProfileService } from '../../../../services/configuration-profile'
import { Enums } from '../../../../models/common'
import { REFERENCE_TYPE_SERVICE_NAME, ReferenceTypeService } from '../../../../services/reference-type'
import { OPERATOR_SECURITY_SERVICE_NAME, OperatorSecurityService } from '../../../../services/operator'
import { Api } from '../../../../modules/api/api.provider'
import { LocalDictionaryFactory } from '../../../../modules/api/api.local-dictionary.factory'
import { ConfigurationProfileCreateEditPopupController } from './configuration-profile-create-edit-popup.directive.controller'

//#endregion

// #region Setup

export class ConfigurationProfileCreateEditPopupDirective implements ng.IDirective {

    restrict = 'E'

    controller = [$SCOPE_SERVICE_NAME,
        $COMPILE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'api',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        REFERENCE_TYPE_SERVICE_NAME,
        OPERATOR_SECURITY_SERVICE_NAME,
        (
            $scope,
            $compile: ng.ICompileService,
            $q,
            $timeout: ng.ITimeoutService,
            api: Api,
            localDictionary: LocalDictionaryFactory,
            userSession: UserSessionService,
            referenceTypeService: ReferenceTypeService,
            operatorSecurityService: OperatorSecurityService,
            configurationProfileService: ConfigurationProfileService
        ) => new ConfigurationProfileCreateEditPopupController(
            $scope,
            $compile,
            $q,
            $timeout,
            api,
            localDictionary,
            userSession,
            referenceTypeService,
            operatorSecurityService,
            configurationProfileService
        )]

    template = TEMPLATE
}

// #endregion